import React from 'react';
import styled from '@emotion/styled';
import { Result } from '../types';
import { CopyIcon } from '../../../components/icons';
import CopyComponent from '../../../components/CopyComponent';

const OuterBox = styled.div`
  box-shadow: 0px 12px 24px -4px rgba(145, 158, 171, 0.12);
  border-radius: 6px;
  width: 440px;
  margin-top: 8px;
`;
const InnerBox = styled.div`
  padding: 8px 16px;
`;
const HeaderInfo = styled.div`
  font-weight: bold;
  margin-top: 30px;
  background: #f7f7f9;
  border-radius: 6px 6px 0px 0px;
  padding: 24px 16px;
  font-size: 18px;
  border-bottom: 1px solid #e5e5ea;
`;
interface Props {
  property: Result;
}
const PropertyInformation = (props: Props) => {
  return (
    <>
      <OuterBox>
        <HeaderInfo>Property Information</HeaderInfo>
        <InnerBox>
          <div style={{ color: '#8E8E93' }}>Street Address</div>
          <div>{props.property?.address}</div>
        </InnerBox>
        <InnerBox>
          <div style={{ color: '#8E8E93' }}>Municipality</div>
          <div>{props.property?.muniTypes[1].name}</div>
        </InnerBox>
        <InnerBox>
          <div style={{ color: '#8E8E93' }}>County</div>
          <div>{props.property?.muniTypes[0].name}</div>
        </InnerBox>
        <InnerBox>
          <div style={{ display: 'flex' }}>
            <div style={{ flexDirection: 'column' }}>
              <div style={{ color: '#8E8E93' }}>State</div>
              <div>{props.property?.muniTypes[0].stateCode}</div>
            </div>
            {props.property.zipCode && (
              <div style={{ flexDirection: 'column', marginLeft: 16 }}>
                <div style={{ color: '#8E8E93' }}>ZIP Code</div>
                <div>{props.property.zipCode}</div>
              </div>
            )}
          </div>
        </InnerBox>
        <InnerBox>
          <div style={{ color: '#8E8E93', display: 'flex' }}>
            {props.property?.muniTypes[0].stateCode !== 'NJ' && <div style={{ width: 60 }}>Section</div>}{' '}
            <div style={{ width: 60 }}>Block</div> <div style={{ width: 40 }}>Lot</div>{' '}
            {props.property?.muniTypes[0].stateCode === 'NJ' && <div style={{ width: 60 }}>Qualifier</div>}
          </div>
          <div style={{ display: 'flex' }}>
            {props.property?.muniTypes[0].stateCode !== 'NJ' && (
              <div style={{ width: 60 }}>{props.property?.property.section}</div>
            )}
            <div style={{ width: 60 }}>{props.property?.property.block}</div>
            <div>{props.property?.property.lot}</div>
            {props.property?.muniTypes[0].stateCode === 'NJ' && (
              <div style={{ width: 60 }}>{props.property.property?.qualifier}</div>
            )}
            <CopyComponent
              style={{
                cursor: 'pointer',
                marginLeft: 8,
              }}
              textToCopy={`${
                props.property?.property.section ? props.property?.property.section + '-' : ''
              } ${props.property?.property.block ? props.property?.property.block + '-' : ''} ${
                props.property?.property.lot ? props.property?.property.lot : ''
              }${props.property?.property.qualifier ? '-' + props.property?.property.qualifier : ''}`}
              afterCopyText="Copied SBL!"
            />
          </div>
        </InnerBox>
        {props.property?.property.propertyClass && (
          <InnerBox>
            <div style={{ color: '#8E8E93' }}>Building Class</div>
            <div>{props.property.buildingDescription || props.property?.property.propertyClass}</div>
          </InnerBox>
        )}
      </OuterBox>
    </>
  );
};

export default PropertyInformation;
